<template>
  <section id="add-branch-block" class="case-creation">
    <div
      class="case-creation__step case-creation__patient-information"
      v-loading="disableSubmitButton"
    >
      <div class="case-creation__card">
        <div class="case-creation__heading">
          <div class="title-with-icon">
            <span class="icon">
              <img
                src="@/assets/images/icons/icon-patient-info.svg"
                alt="icon"
                class="img-fluid"
              />
            </span>
            <h3 class="title">ADD NEW BRANCH</h3>
          </div>
        </div>

        <div class="case-creation__body pb-0">
          <div class="vue-form">
            <el-form :model="branchData">
              <el-row :gutter="30">
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Location
                        <span class="star">*</span>
                      </label>

                      <el-input
                        placeholder="Location"
                        v-model="branchData.ordering_location"
                        
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getBranchValidationErrors &&
                          getBranchValidationErrors.ordering_location
                        "
                      >
                        {{ getBranchValidationErrors.ordering_location }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Display Name
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Display Name"
                        v-model="branchData.display_name"
                        
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getBranchValidationErrors &&
                          getBranchValidationErrors.display_name
                        "
                      >
                        {{ getBranchValidationErrors.display_name }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Location Code
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Location code"
                        v-model="branchData.location_code"
                        
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getBranchValidationErrors &&
                          getBranchValidationErrors.location_code
                        "
                      >
                        {{ getBranchValidationErrors.location_code }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="30">
                <el-col :span="16">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text" class="mb-5">
                        Address
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Address"
                        type="textarea"
                        rows="3"
                        v-model="branchData.address"
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getBranchValidationErrors &&
                          getBranchValidationErrors.address
                        "
                      >
                        {{ getBranchValidationErrors.address }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :span="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <p
                        class="err"
                        v-if="
                          getBranchValidationErrors &&
                          getBranchValidationErrors.critical_error
                        "
                      >
                        {{ getBranchValidationErrors.critical_error }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>

      <div class="case-creation__actions">
        <ul class="list">
          <li>
            <el-button
              size="medium"
              type="default"
              class="btn cancel-button"
              @click="cancelBranchDetails"
              >Cancel</el-button
            >
          </li>
          <li>
            <el-button
              size="medium"
              type="success"
              class="btn save-button"
              @click="submitBranchDetails"
              :disabled="disableSubmitButton"
              :loading="disableSubmitButton"
              >Save</el-button
            >
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      loading: false,
      branchData: {
        ordering_location: "",
        display_name: "",
        location_code: "",
        address: "",
      },
      disableSubmitButton: false,
    };
  },
  computed: {
    ...mapGetters("branches", [
      "getBranchAddStatus",
      "getBranchValidationErrors",
    ]),
    hospital_id() {
      if (this.$route.params.hospital_id) {
        return this.$route.params.hospital_id;
      }
      return null;
    },
  },
  mounted() {
    this.$store.dispatch("branches/clearValidationErrors");
  },
  methods: {
    goToBranches() {
      this.$router.push({ name: "Branches-List" });
    },
    prepareBranchAddData() {
      this.branchData.hospital_id = this.hospital_id;
      return this.branchData;
    },
    scrollToFirstError() {
      let el = this.$el.getElementsByClassName("error")[0];
      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    },
    async submitBranchDetails() {
      this.disableSubmitButton = true;

      const payload = this.prepareBranchAddData();

      await this.$store.dispatch("branches/addBranch", payload);
      if (this.getBranchAddStatus) {
        successNotification("New Branch added successfully");

        this.cancelBranch();
      } else if (this.getBranchValidationErrors) {
        this.scrollToFirstError();
      } else if (!this.getBranchValidationErrors) {
        errorNotification(
          this.getBranchValidationErrors.critical_error ||
            "Error while adding new branch"
        );
      }

      this.disableSubmitButton = false;
    },
    async cancelBranch() {
      this.$router.push({
        name: "Branches-List",
      });
    },
    cancelBranchDetails() {
      if (Object.keys(this.branchData).length === 0) {
        this.clearDataAndGoToBranches();
      } else {
        this.$confirm("Are you sure to cancel adding new Branch?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }).then(() => {
          this.cancelBranch();
        });
      }
    },
    clearDataAndGoToBranches() {
      this.branchData = {};
      this.goToBranches();
    },
  },
  beforeMount() {
    this.$store.commit("branches/setBranchValidationErrors", null, {
      root: true,
    });
    this.$store.commit("errors/clear", null, { root: true });
  },
};
</script>
<style lang="scss" scoped>
#add-branch-block {
  .view-hospital-header {
    margin-top: 10px;
    .hospital-name {
      color: rgba(37, 33, 59, 0.8);
      h3 {
        padding: 5px 20px;

        font-size: 16px;
        text-transform: capitalize;
        .code {
          color: #0a5da6;
          font-weight: 600;
          padding-left: 10px;
        }
        .single-hospital-code {
          color: #f24a55;
          font-weight: 600;
          padding-left: 5px;
        }
      }
    }
  }
}
</style>
